export default {
  authTitle: '活动报名',
  authSubtitle: '登录后即可填写问卷',
  tabPhone: '手机登录',
  tabEmail: '邮箱登录',
  tabWechat: '微信登录',
  phonePlaceholder: '11 位手机号',
  codePlaceholder: '短信验证码',
  emailPlaceholder: '请输入邮箱',
  passwordPlaceholder: '请输入密码',
  phoneRequired: '请输入手机号',
  phoneInvalid: '请输入正确的 11 位大陆手机号',
  codeRequired: '请输入验证码',
  emailRequired: '请输入邮箱',
  emailInvalid: '邮箱格式不正确',
  passwordRequired: '请输入密码',
  login: '登录',
  register: '注册',
  loginSuccess: '登录成功',
  registerLoginSuccess: '注册并登录成功',
  codeSent: '验证码已发送',
  wechatTip: '在微信内点击下方按钮授权登录',
  wechatEnvTip: '微信登录请在微信内置浏览器中打开',
  wechatLogging: '微信登录中…',
  wechatLogin: '微信一键登录',
  wechatNotConfigured: '微信登录未配置，请使用手机或邮箱登录',
  noAccount: '还没有账号？',
  goRegister: '邮箱注册',
  hasAccount: '已有账号？',
  goLogin: '去登录',
  nickname: '昵称',
  nicknamePlaceholder: '请输入昵称',
  email: '邮箱',
  password: '密码',
  passwordConfirm: '确认密码',
  nicknameRequired: '请输入昵称',
  passwordConfirmRequired: '请再次输入密码',
  passwordMismatch: '两次密码不一致',
  registerPendingTitle: '验证邮件已发送',
  registerPendingDesc: '验证邮件已发送至 {email}，请在 {hours} 小时内点击邮件中的链接完成验证。',
  registerPendingHint: '验证完成后，请返回本页使用邮箱和密码登录。',
  registerFlowTip: '填写信息后点击「发送验证邮件」，系统将向您的邮箱发送验证链接；验证通过后方可登录。',
  sendVerifyEmail: '发送验证邮件',
  emailModeLogin: '登录',
  emailModeRegister: '注册',
  emailLoginTip: '请使用已验证的邮箱与密码登录。未验证请先切换到「注册」发送验证邮件。',
  passwordConfirmPlaceholder: '请再次输入密码',
  verifySuccessTitle: '邮箱验证成功',
  verifyFailedTitle: '验证失败',
  verifyConflictTitle: '无法验证',
  verifyMissingToken: '缺少验证 token，请从邮件中的链接进入',
  verifyNetworkError: '网络异常，请稍后重试',
  logout: '退出登录'
}
